import {
  InteractionType,
  LogLevel,
  PublicClientApplication,
  type BrowserCacheLocation,
  type IPublicClientApplication,
} from "@azure/msal-browser";

import { environment } from "../../../environments/environment";

import type { MsalGuardConfiguration, MsalInterceptorConfiguration } from "@azure/msal-angular";


/**
 * MSAL Logging Configuration
 */
export function loggerCallback(_logLevel: LogLevel, _message: string): void {}

/**
 * MSAL Instance Factory
 * Creates and initializes the MSAL PublicClientApplication
 */
export function MSALInstanceFactory(): IPublicClientApplication {
  // Derive redirect URIs from the actual browser origin so that
  // localhost stays on localhost and deployed envs use their own host.
  const origin = window.location.origin;
  return new PublicClientApplication({
    auth: {
      clientId: environment.msalConfig.auth.clientId,
      authority: environment.msalConfig.auth.authority,
      redirectUri: `${origin}/`,
      postLogoutRedirectUri: `${origin}/login`,
    },
    cache: {
      cacheLocation: environment.msalConfig.cache.cacheLocation as BrowserCacheLocation,
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: environment.production ? LogLevel.Error : LogLevel.Info,
        piiLoggingEnabled: !environment.production,
      },
    },
  });
}

/**
 * MSAL Guard Configuration
 * Defines how the guard should handle authentication
 */
export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect, // Or InteractionType.Popup
    authRequest: {
      scopes: environment.scopes.loginRequest,
    },
    loginFailedRoute: "/login-failed", // Where to redirect if login fails
  };
}

/**
 * MSAL Interceptor Configuration
 * Automatically adds access tokens to HTTP requests
 */
export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();

  // Add your protected resources here
  // Microsoft Graph API
  protectedResourceMap.set("https://graph.microsoft.com/v1.0/me", ["User.Read"]);
  protectedResourceMap.set("https://graph.microsoft.com/v1.0/me/photo/$value", ["User.Read"]);

  // Your backend API (if applicable)
  // Uncomment and configure if you have a backend API:
  // protectedResourceMap.set("https://your-api.example.com/api", environment.apiConfig.scopes);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}
